var map = {
	"./learning/learning.module.ngfactory": [
		"./src/app/learning/learning.module.ngfactory.js",
		"default~learning-learning-module-ngfactory~payments-payments-module-ngfactory~pros-pros-module-ngfactory",
		"learning-learning-module-ngfactory"
	],
	"./payments/payments.module.ngfactory": [
		"./src/app/payments/payments.module.ngfactory.js",
		"default~learning-learning-module-ngfactory~payments-payments-module-ngfactory~pros-pros-module-ngfactory",
		"payments-payments-module-ngfactory"
	],
	"./players/players.module.ngfactory": [
		"./src/app/players/players.module.ngfactory.js",
		"players-players-module-ngfactory"
	],
	"./pros/pros.module.ngfactory": [
		"./src/app/pros/pros.module.ngfactory.js",
		"default~learning-learning-module-ngfactory~payments-payments-module-ngfactory~pros-pros-module-ngfactory",
		"pros-pros-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;